import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { AuditoriaHeader } from "./AuditoriaHeader";
import { SeccionCambios } from "./SeccionCambios";
import { SeccionDocumentos } from "./SeccionDocumentos";

/**
 * Página de auditoría · 4 tabs.
 *   · 3 tabs reusan `SeccionCambios` con scope distinto (operaciones,
 *     accesos, admin) · cada uno tiene su categoría set propio.
 *   · 1 tab para documentos (carga / eliminación con motivo).
 *
 * Radix Tabs solo monta el `TabsContent` activo (sin `forceMount`) · igual
 * comportamiento que `keepMounted={false}` de Mantine: evita que las 3
 * secciones de cambios pidan al server simultáneamente al primer render.
 */
export function AdminAuditoriaPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <AuditoriaHeader />
      <Tabs defaultValue="operaciones">
        <TabsList className="mb-4">
          <TabsTrigger value="operaciones">Operaciones</TabsTrigger>
          <TabsTrigger value="accesos">Accesos</TabsTrigger>
          <TabsTrigger value="admin">Cambios administrativos</TabsTrigger>
          <TabsTrigger value="documentos">Documentos</TabsTrigger>
        </TabsList>
        <TabsContent value="operaciones">
          <SeccionCambios scope="operaciones" />
        </TabsContent>
        <TabsContent value="accesos">
          <SeccionCambios scope="accesos" />
        </TabsContent>
        <TabsContent value="admin">
          <SeccionCambios scope="admin" />
        </TabsContent>
        <TabsContent value="documentos">
          <SeccionDocumentos />
        </TabsContent>
      </Tabs>
    </div>
  );
}
